import React, { useEffect, useState } from "react";
import {
  getAllRatingList,
  getAllRatingsList,
} from "../../../redux/booking/action";
import { useDispatch, useSelector } from "react-redux";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import SubcategoryFilter from "../../Common/Filter/SubcategoryFilter";
import search from "../../assets/images/search-lg.svg";
import RatingHeader from "./RatingHeader";
import RatingFilter from "./RatingFilter";
import * as XLSX from "xlsx";
import axiosInstance from "../../../redux/api";
// import search from "../../assets/images/search-lg.svg"
import NormalCardHeader from "../../Common/CardHeader/NormalCardHeader";




const RatingList = () => {
  const dispatch = useDispatch();
  const [openFilter, setOpenFilter] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    per_page: "10",
    // start_date: "",
    // end_date: "",
    // business_id: "",
    search_key: "",
    type: 1,
  });
  const [paramsList, setParamsList] = useState({
    page: 1,
  });
  const ratings = useSelector((state) => state?.bookingSlice?.getRatingList);
  console.log(ratings, "ratings---");

  useEffect(() => {
    dispatch(getAllRatingsList(params));
  }, [dispatch, params]);
  const pagination_meta = ratings?.pagination;

  const handlePageChange = (newPage) => {
    setParams((prevParams) => ({
      ...prevParams,
      page: newPage,
    }));
  };

  //  csv file convert
  const handleExportCSV = async (e) => {
    e.preventDefault();

    const filterParams = {
      ...params,
      page: "",
      from_date: "",
      to_date: "",
    };

    try {
      const response = await axiosInstance.post(`rating/rating_list`, filterParams);
      const data = response?.data?.response?.ratings || [];

      if (!data.length) return;

      const header = [
        [
          "S. No",
          "Customer Name",
          "Product Name",
          "Type",
          "Date",
          "Review",
          "Rating Value",
        ],
      ];

      const body = data.map((item, index) => [
        index + 1,
        `${item?.created_by_first_name || ""} ${item?.created_by_last_name || ""}`,
        item?.product_name || "",
        item?.type === 1 ? "Product" : item?.type === 2 ? "Delivery" : "Other",
        item?.created_on || "",
        item?.review || "",
        item?.rating_value || "",
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet(header);
      XLSX.utils.sheet_add_aoa(worksheet, body, { origin: "A2" });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "RatingList");

      XLSX.writeFile(workbook, "RatingList.csv", { bookType: "csv" });
    } catch (error) {
      console.error("Rating Export Error:", error);
    }
  };

  const handleDeleteRating = async (ratingId) => {
    if (!ratingId) return;

    try {
      await axiosInstance.delete(`rating/delete_rating/${ratingId}`);
    } catch (error) {
      console.error("Delete Rating Error:", error);
    }

    dispatch(getAllRatingsList(params));
  }


  return (
    <div className=" card-head order-card">
      <div className="sub-head">
        <h4>Rating List</h4>
      </div>

      {/* <div
                onClick={() => setOpenFilter(false)}
                className={openFilter ? `overlay show` : "overlay"}
            ></div> */}
      {/* <RatingFilter
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
                params={params}
                paramsList={paramsList}
                setParams={setParams}
            /> */}
      <RatingHeader
        params={params}
        setParams={setParams}
        // addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <div className="table-category mt-3">
        <div className="table-first-top d-flex justify-content-between align-items-center">
          
          <div className="d-flex justify-content-end align-items-center table-right">
            {/* Filter by
            <select>
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select> */}
            <button className="btn btn-primary" onClick={handleExportCSV}>
              Export CSV
            </button>
          </div>
        </div>
        <div className="table-sec table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Contact info</th>
                <th>Images</th>
                <th>Product Name</th>
                <th>Type</th>
                <th>Date</th>
                <th>Review</th>
                <th>Rating Value</th>
                <th>Delete Rating</th>
              </tr>
            </thead>
            <tbody>
              {ratings?.ratings?.length > 0 ? (
                ratings.ratings.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (params?.page - 1) * 10}</td>
                    <td className="w-25">
                      {item?.created_by_first_name || null} 
                      <br />
                      {item?.email_id || null}
                      <br />
                      {item?.mobile_number || null} 
                    </td>

                    {/* Render images here */}
                    <td>
                      <div className="d-flex flex-wrap gap-2">
                        {item?.images?.length > 0 ? (
                          item.images.map((img, imgIndex) => (
                            <div key={imgIndex}>
                              <img
                                src={img}
                                alt={`rating-img-${imgIndex}`}
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "cover",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>
                          ))
                        ) : (
                          <span className="text-muted">No Images</span>
                        )}
                      </div>
                    </td>


                    <td>{item?.product_name}</td>
                    <td>{item?.type === 1 ? "Product" : item?.type === 2 ? "Delivery" : "Other"}</td>
                    <td>{item?.created_on}</td>
                    <td className="w-25">{item?.review}</td>
                    <td>{item?.rating_value}</td>
                    <td>
                      <button
                      style={{backgroundColor: "transparent", padding: "5px 10px", borderRadius: "4px", cursor: "pointer"}}
                      onClick={() => handleDeleteRating(item?.id)}
                      >Delete</button>
                      </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-reports text-center">
                    No ratings found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
          {/* <CommonPagination params={params} setParams={setParams} pagination_meta={ratings?.pagination_meta} /> */}

          {/* Pagination Component */}
        </div>
        <div className="pagination-section">
          {pagination_meta && (
            <div className="">
               <select
              className="form-select"
              value={params.per_page || 10}
              onChange={(e) =>
                setParams((prev) => ({
                  ...prev,
                  page: 1, 
                  per_page: e.target.value,
                }))
              }
              style={{ width: "100px" }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
                <CommonPagination
              currentPage={pagination_meta.current_page}
              totalPages={pagination_meta.pages}
              onPageChange={handlePageChange}
            />
            </div>
          
          )}
        </div>
      </div>
    </div>
  );
};

export default RatingList;
